import React from 'react';
import { usePrefs } from 'wsm-common-data';
import PropTypes from 'prop-types';

import FormattedTitle from './FormattedTitle';
import VehicleCard from './VehicleCard';

const VehicleCards = ({
	inventorySearchResults = {},
	searchTerm = '',
	triggerTrackingEvent = {}
}) => {
	const { showVehicleCards, vehicleCardImage } = usePrefs();

	if (
		showVehicleCards === 'true' &&
		inventorySearchResults &&
		inventorySearchResults.vehicles &&
		inventorySearchResults.vehicles.length > 0
	) {
		const { vehicles } = inventorySearchResults;

		let keyCount = -1;

		return vehicles.map(vehicle => {
			const {
				path,
				images: [image1, image2],
				title
			} = vehicle;

			const titleString =
				title instanceof Array ? title.join(' ') : title;
			const image =
				image2 && vehicleCardImage === 'secondary' ? image2 : image1;
			keyCount += 1;

			return (
				<VehicleCard
					href={path || null}
					imageUrl={image.url}
					imageAlt={titleString}
					triggerTrackingEvent={triggerTrackingEvent}
					key={keyCount}
				>
					<FormattedTitle searchTerm={searchTerm}>
						{titleString}
					</FormattedTitle>
				</VehicleCard>
			);
		});
	}
	return '';
};

VehicleCards.propTypes = {
	inventorySearchResults: PropTypes.shape({}),
	searchTerm: PropTypes.string,
	triggerTrackingEvent: PropTypes.func
};

export default VehicleCards;
